import { SxProps, Theme } from '@mui/material/styles';

import { orderColumnsForDisplay } from 'src/helpers/columnsLayoutUtils';
import {
  ColumnAlignH,
  ColumnAlignV,
  IPageColumn,
} from 'src/interfaces/PageColumn';
import { HeroMobileStackOrder } from 'src/interfaces/HeroBlock';
import { IPageBlock } from 'src/interfaces/PageBlock';

const alignItemsMap: Record<ColumnAlignH, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const justifyContentMap: Record<ColumnAlignV, string> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

export function columnFlexSx(alignH: ColumnAlignH, alignV: ColumnAlignV): SxProps<Theme> {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignItemsMap[alignH],
    justifyContent: justifyContentMap[alignV],
    gap: 2,
    width: '100%',
    flex: 1,
    minHeight: '100%',
    alignSelf: 'stretch',
  };
}

/** Block types that should fill the column width (not shrink to intrinsic content). */
const COLUMN_FULL_WIDTH_BLOCK_TYPES: ReadonlySet<IPageBlock['type']> = new Set([
  'text',
  'divider',
  'signupFlow',
  'competitionsList',
  'results',
  'sponsors',
  'trackMap',
  'map',
  'calendar',
  'countdown',
  'columns',
]);

/** Wrapper sx for blocks inside a column; only full-width types stretch. */
export function columnNestedBlockWrapperSx(block: IPageBlock): SxProps<Theme> {
  if (COLUMN_FULL_WIDTH_BLOCK_TYPES.has(block.type)) {
    return { alignSelf: 'stretch', width: '100%', minWidth: 0 };
  }
  return { maxWidth: '100%', minWidth: 0 };
}

export function orderColumnsForMobile(
  columns: IPageColumn[],
  stackOrder: HeroMobileStackOrder = 'column1First',
): IPageColumn[] {
  const order =
    columns.length === 2 && stackOrder === 'column2First' ? [1, 0] : undefined;
  return orderColumnsForDisplay(columns, order);
}
